import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { AlternatePaymentsEffects } from './alternate-payments.effects';

@NgModule({
  declarations: [],
  imports: [CommonModule, EffectsModule.forFeature([AlternatePaymentsEffects])],
})
export class AlternatePaymentsModule {}
